export class Log {
    id: string;
    created_userid: string;
    created_at: string;
    old: any;
    new: any;
    creator: any;
    type: any;

}



// WEBPACK FOOTER //
// ./src/app/model/log.ts